module.exports = __webpack_public_path__ + "img/dimension-bg.13e31e9b.png";